module.exports = __webpack_public_path__ + "static/playlist-wires.76623ec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/playlist-wires.png
// module id = 474
// module chunks = 261706647590803